import React, { useEffect, useState } from "react";
import { Hooks,Platform, Util } from "@xt/xtbase";
const {useTranslation, useDocumentWidth} = Hooks;
const {getUrl} = Util;
import styles from "./index.module.less";
import {getAppVersions} from "@/api/xt-app";
import dotted from "@/assets/images/home/dotted.png";
import sigh from "@/assets/images/home/sigh.png";
import browser from "@/assets/images/home/browser.png";
import right from "@/assets/images/home/right.png";
import downloadImg from "@/assets/images/home/downloadImg.png";
import downloadH5 from "@/assets/images/home/downloadH5.png";
// import QrCode from "@xt/QrCode";
// import QRCode from "qrcode.react";
import {QRCodeSVG} from 'qrcode.react';

function AndroidIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="65" height="65" viewBox="0 0 65 65" fill="none" aria-hidden>
      <path fillRule="evenodd" clipRule="evenodd" d="M48.4043 47.1484C48.4042 48.9309 46.9624 50.3896 45.2002 50.3896H42.5576V57.8105C42.5574 60.0408 41.1473 61.8661 39.4248 61.8661H38.7295C37.007 61.8661 35.5969 60.0408 35.5967 57.8105V50.3896H29.709V57.7245C29.7089 59.9552 28.3003 61.7809 26.5771 61.7812H25.8809C24.1583 61.7812 22.7481 59.9553 22.748 57.7245V50.3896H19.8672C18.1049 50.3896 16.6632 48.9309 16.6631 47.1484V21.4696H48.4043V47.1484ZM54.4033 21.747C56.1267 21.747 57.5361 23.5717 57.5361 25.8027V38.8163C57.5361 41.048 56.1266 42.8729 54.4033 42.873H53.707C51.9844 42.873 50.5743 41.048 50.5742 38.8163V25.8027C50.5742 23.5716 51.9844 21.747 53.707 21.747H54.4033ZM11.3291 21.6698C13.0523 21.6701 14.4609 23.4948 14.4609 25.7255V38.7392C14.4609 40.9695 13.0523 42.7955 11.3291 42.7958H10.6328C8.9098 42.7958 7.5 40.9697 7.5 38.7392V25.7255C7.5 23.4946 8.9098 21.6698 10.6328 21.6698H11.3291ZM42.2715 3.18156C42.4017 2.99142 42.661 2.9422 42.8496 3.07413L42.9248 3.12687C43.1134 3.25823 43.1615 3.522 43.0312 3.71183L39.9893 8.17374C44.3787 10.4075 47.5164 14.5214 48.166 19.3583H16.6543C17.3193 14.4106 20.5867 10.22 25.1338 8.02238L22.2422 3.78312C22.1127 3.59267 22.1601 3.32855 22.3486 3.19718L22.4248 3.14445C22.6133 3.01342 22.8735 3.0618 23.0029 3.25187L25.9941 7.63761C27.9558 6.82502 30.127 6.37395 32.4102 6.37394C34.8169 6.37394 37.0973 6.87483 39.1416 7.7714L42.2715 3.18156ZM25.7754 11.3876C24.9089 11.3878 24.2051 12.0994 24.2051 12.9765C24.2052 13.8533 24.909 14.5652 25.7754 14.5653C26.6429 14.5653 27.3465 13.8534 27.3467 12.9765C27.3467 12.0993 26.643 11.3876 25.7754 11.3876ZM39.3311 11.3876C38.4641 11.3876 37.7598 12.0993 37.7598 12.9765C37.7599 13.8534 38.4642 14.5653 39.3311 14.5653C40.1985 14.5652 40.9012 13.8534 40.9014 12.9765C40.9014 12.0994 40.1986 11.3877 39.3311 11.3876Z" fill="#FDFDFD"/>
    </svg>
  );
}

function AppleIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="65" height="65" viewBox="0 0 65 65" fill="none" aria-hidden>
      <path d="M32.9541 19.8242C34.8441 19.8242 40.0055 16.7395 44.7227 17.1074C49.7048 17.4826 53.4844 19.4284 55.9824 22.9658C51.5161 25.6468 49.3044 29.2832 49.333 34.1084C49.333 34.3558 48.8676 42.1458 57.5361 46.1855C55.9185 51.0247 50.3631 61.771 43.8994 61.8633C40.1628 61.8632 37.9724 59.5147 33.7422 59.5146C29.3826 59.5146 27.0129 61.7852 23.6631 61.8633C17.2564 62.0542 11.1147 50.2322 9.41113 45.4072C8.13717 41.7423 7.50002 38.1838 7.5 34.7383C7.5 23.0789 15.3807 17.3484 22.7969 17.2354C26.3901 17.2354 30.9567 19.8239 32.9541 19.8242ZM45.001 3C45.1083 4.39394 45.4377 8.27116 41.8086 12.5303C39.2029 15.537 36.039 17.298 32.5742 17.0361C32.2812 13.4071 33.6484 10.1885 35.9746 7.58496C38.0864 5.15827 41.7942 3.18391 45.001 3Z" fill="#FDFDFD"/>
    </svg>
  );
}

function GooglePlayIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="65" height="65" viewBox="0 0 65 65" fill="none" aria-hidden>
      <path fillRule="evenodd" clipRule="evenodd" d="M42.2092 42.1775L54.6018 34.4357C55.0976 34.1687 55.5934 33.3676 55.5934 32.8338V32.0327C55.5934 31.232 55.3455 30.698 54.6018 30.4309L42.2092 22.689L34.0299 32.2998L42.2092 42.1775ZM32.0459 29.8969L39.4818 20.82L11.9695 3.20009C11.474 2.9333 10.9782 2.9333 10.4827 3.20009L32.0459 29.8969ZM32.0459 34.9691L10.4827 61.6656C10.9782 61.9327 11.474 61.9327 11.9695 61.6656L39.4818 44.3131L32.0459 34.9691ZM8.5 5.86967V58.7293L30.0635 32.2995L8.5 5.86967Z" fill="#FDFDFD"/>
    </svg>
  );
}

const HomeDownload = (props) => {
  const t = useTranslation();
  const domeWidth = (useDocumentWidth() ?? 0) > 768
  const [showDownloadGuide, setShowDownloadGuide] = useState(false);
  const [appList, setAppList] = useState(props.appList || []);
  const onDownLoad = (type)=>{
    if (Platform.isWeiXin() && ["android", "android-google-play"].includes(type)) {
      setShowDownloadGuide(true);
    } else {
      const client = appList.find((item) => item.client === type);
      window.open(client.url, type === "windows" ? "_self" : "_blank");
    }
  }
  useEffect(()=>{
    if(appList && appList.length > 0)
      return;
    getAppVersions().then((res) => {
      setAppList(Array.isArray(res) ? res : []);
    });
  },[]);
  return <div className={`app-download-container ${styles["app-download-container"]}`}>
    {showDownloadGuide ? <div className={styles["app-download-guide"]} onClick={()=>{setShowDownloadGuide(false)}}>
      <img className={styles["guide-arrow"]} src={dotted} />
      <ul>
        <li>
          <span>1</span>
          { t("home.Clickrightcorner") }
          <img src={sigh} />
          { t("home.Button") }
        </li>
        <li>
          <span>2</span>{t("home.choose") }
          <img src={browser} />
        </li>
      </ul>
    </div> : null}
    <article>
      <div className={`app-download-container-load ${styles["load-pane"]} ${styles["app-download-container-load"]}`}>
        <div className={styles["pane"]}>
          <div className={styles.paneLeft} style={{backgroundImage:`url(${downloadImg})`}}>
          </div>
          <div className={styles.paneLeftH5} style={{backgroundImage:`url(${downloadH5})`}}>
            <p className={styles.paneLeftH5Title}>{t('home.TradeAnywhere')}</p>
          </div>
          <div className={styles.paneRight}>
            <p className={styles.paneRightP1}>{t('home.DownloadXTClient')}</p>
            <p className={styles.paneRightP2}>{t('home.TradeAnywhere')}</p>
            <p className={styles.paneRightP3}>{t('home.anytimeandanywhere')}</p>
            <ul className={styles["pane-tool"]}>
              <div className={styles["pane-tool-con"]}>
                <li className={styles["download-item"]} onClick={() => { onDownLoad('android') }}>
                  <div className={styles["download-icon-android"]}><AndroidIcon /></div>
                  <div className={styles["download-text"]}>
                    <span className={`${styles["download-text-bottom"]} ${styles["font-family-bold"]}`}>Android</span>
                    <span className={styles["download-text-getit"]}>{t('home.downloadGetItOn')}</span>
                  </div>
                </li>
                <li className={styles["download-item"]} onClick={() => { onDownLoad('ios') }}>
                  <div className={styles["download-icon-ios"]}><AppleIcon /></div>
                  <div className={styles["download-text"]}>
                    <span className={`${styles["download-text-bottom"]} ${styles["font-family-bold"]}`}>App Store</span>
                    <span className={styles["download-text-getit"]}>{t('home.downloadGetItOn')}</span>
                  </div>
                </li>
                <li className={styles["download-item"]} onClick={() => { onDownLoad('android-google-play') }}>
                  <div className={styles["download-icon-google"]}><GooglePlayIcon /></div>
                  <div className={styles["download-text"]}>
                    <span className={`${styles["download-text-bottom"]} ${styles["font-family-bold"]}`}>Google Play</span>
                    <span className={styles["download-text-getit"]}>{t('home.downloadGetItOn')}</span>
                  </div>
                </li>
              </div>
            </ul>
            <ul className={styles["pane-tip"]}>
          <li className={styles["pane-tip-item"]}>
            <img src={right} alt="" />
            <span className={styles["font-family-normal"]}>{ t("home.24/7Service") }</span>
          </li>
          <li className={styles["pane-tip-item"]}>
            <img src={right} alt="" />
            <span className={styles["font-family-normal"]}>{ t("home.OperatingModel") }</span>
          </li>
        </ul>
          </div>
        </div>
        
        {/* <div className={styles["phone-tool"]}>
          <div className={styles["download-icon-google"]} style={{"backgroundImage":`url(${theme=="light"?google_d:google_w})`}} onClick={()=>{onDownLoad('android-google-play')}}></div>
          <div className={styles["download-icon-android"]} style={{"backgroundImage":`url(${theme=="light"?android_d:android_w})`}} onClick={()=>{onDownLoad('android')}}></div>
          <div className={styles["download-icon-ios"]} style={{"backgroundImage":`url(${theme=="light"?ios_d:ios_w})`}} onClick={()=>{onDownLoad('ios')}}></div>
        </div> */}
      </div>
    </article>
  </div>;
}
export default HomeDownload;